import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/list-duck';
import { Vehicle, VehicleOption } from 'interfaces/vehicle';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess'],
    success: ['data'],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'LIST_REGIONAL_' }
);

export interface ListRegionalState extends IState {
  data: VehicleOption[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: Vehicle[];
}

const INITIAL_STATE: ListRegionalState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListRegionalState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: ListRegionalState, action: ISuccessListUnitsAction) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListRegionalState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listRegional = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListRegionalTypes = Types;
export const ListRegionalActions = Creators;
